export const ArrowLeft = ({ fill }: { fill: string }) => (
  <svg width="16" height="16" viewBox="0 0 16 16">
    <path
      fill={fill}
      d="M5.99967 12.6673L6.93967 11.7273L3.88634 8.66732H14.6663V7.33398H3.88634L6.94634 4.27398L5.99967 3.33398L1.33301 8.00065L5.99967 12.6673Z"
    />
  </svg>
);
